var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1Completed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9344_8869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.875 52.25C34.3275 52.25 29 46.9225 29 40.375C29 33.8275 34.3275 28.5 40.875 28.5C47.4225 28.5 52.75 33.8275 52.75 40.375C52.75 46.9225 47.4225 52.25 40.875 52.25ZM40.875 31C35.705 31 31.5 35.205 31.5 40.375C31.5 45.545 35.705 49.75 40.875 49.75C46.045 49.75 50.25 45.545 50.25 40.375C50.25 35.205 46.045 31 40.875 31ZM40.115 45.1038L35.3812 40.5237L37.12 38.7262L40.1375 41.6462L45.8925 36.215L47.6088 38.0337L40.115 45.1038Z",
    fill: "#00D122"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.5H37C39.2091 3.5 41 5.29086 41 7.5V25.5H44V7.5C44 3.63401 40.866 0.5 37 0.5H7C3.13401 0.5 0 3.63401 0 7.5V37.5C0 41.366 3.13401 44.5 7 44.5H26V41.5H7C4.79086 41.5 3 39.7091 3 37.5V7.5C3 5.29086 4.79086 3.5 7 3.5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3065 28.2349H17.9112C17.8411 28.5655 17.8071 28.9379 17.8071 29.3544C17.8071 29.7699 17.8422 30.1525 17.9112 30.5H27.7266C27.7956 30.1706 27.8307 29.7925 27.8307 29.368C27.8307 28.9424 27.7956 28.5655 27.7266 28.2349H25.9302L24.3941 28.2598L24.4201 26.5154V13.6302C24.0386 13.543 23.6085 13.5 23.1308 13.5C22.6531 13.5 22.2331 13.5441 21.8686 13.6302C21.0525 15.4527 19.4292 17.1189 17 18.629C17.1392 19.358 17.5207 19.8957 18.1456 20.2432C19.6726 19.5663 20.9223 18.629 21.8947 17.4313C21.8075 19.2538 21.7645 20.3043 21.7645 20.5816V26.5177L21.7905 28.2621L20.3065 28.2349Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9344_8869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Completed);
export default __webpack_public_path__ + "static/media/step1-completed.624ed76653b92ca16d9dd0b73a928ac3.svg";
export { ForwardRef as ReactComponent };